// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__26XVj","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1mqY4","obliqueLine":"membershipbadge_obliqueLine__wPDUm"};